import { friendlyApiErrorMessage } from 'src/app/services/api-error-notifier.service';
import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Optional, Output, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subscription } from 'rxjs';
import { ApiService } from 'src/app/services/api.service';
import { FilterService } from 'src/app/services/filter.service';
import { PageDataService, InteractiveFilter } from 'src/app/services/page-data.service';

@Component({
    selector: 'app-waterfall-card',
    templateUrl: './waterfall-card.component.html',
    styleUrls: ['./waterfall-card.component.scss'],
    standalone: false
})
export class WaterfallCardComponent implements OnInit, OnDestroy {
  static key = 100826;

  @Input('item') item: any;
  @Input('pageKey') pageKey: any;
  @Output('onSizeChange') onSizeChange = new EventEmitter<any>();
  @ViewChild('chartDiv', { static: true }) chartDiv!: ElementRef;

  config: any;
  data: any;
  heading: any;
  isDataLoaded = false;
  reqSubscription: Subscription[] = [];
  error_name: any;

  constructor(
    private filterService: FilterService,
    private httpClient: HttpClient,
    private apiService: ApiService,
    @Optional() private pageDataService: PageDataService,
  ) {
    // Always keep filterQuery subscription as fallback
    this.reqSubscription.push(
      this.filterService.filterQuery.subscribe((query: any) => {
        // Only make independent API calls when PageDataService is NOT managing data
        if (!this.pageDataService?.isActive) {
          this.loadApiData();
        }
      })
    );
  }

  ngOnInit(): void {
    const observer = new ResizeObserver((e: any) => {
      this.onSizeChange.emit(e[0].contentRect.height);
    });
    observer.observe(this.chartDiv.nativeElement);
    this.loadChartConfig();

    // Page-level data mode — subscribe to shared data stream
    if (this.pageDataService) {
      // Show loader when PageDataService is fetching
      // this.reqSubscription.push(
      //   this.pageDataService.loading$.subscribe(loading => {
      //     if (loading) {
      //       this.isDataLoaded = false;
      //     }
      //   })
      // );

      const listOfApi = this.item.config['list_of_api'] || '';
      const apiKey =  listOfApi;
      const stream$ = apiKey
        ? this.pageDataService.getDataStream(String(apiKey))
        : this.pageDataService.getCommonDataStream();

      this.reqSubscription.push(
        stream$.subscribe(res => {
          if (res && res.length > 0) {
            this.isDataLoaded = true;
            this.data = res;
            this.error_name = '';
          }
        })
      );
    }
  }

  loadChartConfig() {
    this.heading = this.item.config['report_heading'];
    this.config = {
      xAxisLabel: this.item.config['x_axis']?.['api_resp_column_display_nm'] || '',
      yAxisLabel: this.item.config['y_axis']?.['api_resp_column_display_nm'] || '',
      xAxisVar: this.item.config['x_axis']?.['api_resp_column_nm'] || '',
      yAxisVar: this.item.config['y_axis']?.['api_resp_column_nm'] || '',
      value_column: this.item.config['value_column']?.['api_resp_column_nm'] || '',
      displayType: 'value',
    };
  }

  /** Handle segment click from waterfall chart for cross-filtering */
  onSegmentClicked(event: { column: string; value: any }) {
    if (this.pageDataService) {
      this.pageDataService.applyInteractiveFilter({
        sourceWidgetKey: WaterfallCardComponent.key,
        column: event.column,
        value: event.value,
        operator: 'equals',
      });
    }
  }

  loadApiData(reportType?: string) {
    let api = this.item.config['list_of_api'] || {};
    
    if (api && (this.filterService.isEmptyObject(this.filterService.baseQuery) == false)) {
      let obj: any = { "api_key": api };

      let query = Object.assign({}, this.filterService.baseQuery, obj);
      query["report_typ"] = this.filterService.report_type;
      query['module_key'] = this.apiService.getModuleKey();
      let endPoint = this.item.config?.["widget_endpoint"] || '';

      this.reqSubscription.push(
        this.httpClient.post(`${this.apiService.apiBaseUrl}/${endPoint || this.apiService.executionUrl}`, query).subscribe((res: any) => {
          this.isDataLoaded = true;
          this.data = res == null ? [] : res;
          this.error_name = '';
        }, (err: any) => {
          this.data = [];
          this.error_name = friendlyApiErrorMessage(err);
          console.log(err);
        })
      );
    }
  }

  ngOnDestroy(): void {
    this.reqSubscription.forEach(res => res.unsubscribe());
  }
}
